/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'fund-phase-operating': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g _fill="#06c" fill-rule="nonzero"><rect pid="0" y="11" width="4" height="5" rx="1"/><rect pid="1" x="6" y="6" width="4" height="10" rx="1"/><rect pid="2" x="12" y="1" width="4" height="15" rx="1"/></g>'
  }
})
